export default __webpack_public_path__ + "static/media/centro_odontologico_neuquen.ab478754.jpg";